import https from "./https";
import store from "@/store"

const organization = store.state.general.organization;

const lushApi = {
  query(params) {
    return https.get(
      `admin/organizations/${organization.id}/lush/query`,
      { params }
    );
  },
};

export default lushApi
